import { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap-v5'
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';
import ArquivoEmpresaService from '../../services/ArquivoEmpresaService';
import Swal from 'sweetalert2';
import ReactS3Client from 'react-aws-s3-typescript';
import { configBucket } from '../../utils/S3Utils';
import { IArquivoEmpresa } from '../../interfaces/IArquivoEmpresa';

const ModalArquivosIniciais = ({ esteiraID, empresaID, show, toggleModal }: { show: boolean, toggleModal: Function, esteiraID: number, empresaID: number }) => {
    const { t } = useTranslation();
    const [arquivos, setArquivos] = useState<any[]>([]);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [loadingFile, setLoadingFile] = useState<boolean>(false);

    const onChangeFile = useCallback(async (e: any) => {

        if (e.target.files !== null && e.target.files.length > 0) {
            setLoadingFile(true);
            const file = e.target.files[0] as File;

            if (!file.name.includes(".xls")) {
                Swal.fire({
                    text: 'Por favor anexar apenas arquivo em excel para o saldo inicial!',
                    timer: 3000,
                    icon: 'error',
                    showConfirmButton: false
                });
                setLoadingFile(false);
                return;
            }

            const s3 = new ReactS3Client(configBucket);
            const res = await s3.uploadFile(file, file.name);
            const item = { esteiraID, empresaID: empresaID, nome: file.name, url: res.location, id: 0, tipo: 'Saldo Inicial' } as IArquivoEmpresa;
            ArquivoEmpresaService.cadastrarArquivo(item).then((result) => {
                Swal.fire({
                    text: 'Arquivo importado com sucesso!',
                    timer: 3000,
                    icon: 'success',
                    showConfirmButton: false
                });

                setArquivos((old) => {
                    const copy = [...old];
                    copy.push({ ...item, id: result.id, });
                    return copy;
                });

                setLoadingFile(false);
            });
        }
    }, [empresaID, esteiraID]);

    useEffect(() => {
        if (!empresaID || !esteiraID || !show) return;

        ArquivoEmpresaService.buscarTodos(empresaID, esteiraID).then((resp) => {
            setArquivos(resp);
            setLoaded(true);
        }).catch(() => {
            Swal.fire({
                text: 'Ocorreu um erro ao buscar os arquivos anexados a empresa!',
                timer: 3000,
                icon: 'error',
                showConfirmButton: false
            });
        });

        const interval = setInterval(() => {
            ArquivoEmpresaService.buscarTodos(empresaID, esteiraID).then((resp) => {
                setArquivos(resp);
                setLoaded(true);
            })
        }, 900000); // 15 minutos

        return () => clearInterval(interval);
    }, [show, empresaID, esteiraID]);

    return (
        <>
            <Modal size='lg' centered={true} show={show} onHide={() => { }}>
                <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
                    <div className="modal-header">
                        <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>Arquivos Iniciais</h5>
                        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                            <button onClick={() => toggleModal()} style={{ backgroundColor: 'none', border: 'none' }}>
                                <i className="fas fa-times" style={{ color: '#5E6397' }}></i>
                            </button>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className='col-md-12 mt-2'>
                                <p>Para continuar o processamento e conciliações das contas é necessário uma etapa adicional.</p>
                                <p>Caso você tenha arquivos de saldo inicial para importar, por favor selecione-os abaixo (um por vez).</p>
                            </div>
                            <div className="col-md-12 mt-2">
                                <label>Selecione um arquivo para importar</label>
                                {loadingFile ? <p>Carregando...</p> : (
                                    <div className="form-group mt-2">
                                        <input type='file' placeholder='Anexar...' accept='*' onChange={(e) => onChangeFile(e)} className="form-control" />
                                    </div>)
                                }
                            </div>
                            {arquivos.filter(f => f.tipo === 'Saldo Inicial' && !f.processado && f.processando).length > 0 && (
                                <div className='col-md-12 mt-2'>
                                    <p>Arquivos processando:</p>
                                    <ul>
                                        {arquivos.filter(f => f.tipo === 'Saldo Inicial' && !f.processado && f.processando).map((item) => (
                                            <li key={item.id}>{item.nome}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            {arquivos.filter(f => f.tipo === 'Saldo Inicial' && !f.processado && !f.processando).length > 0 && (
                                <div className='col-md-12 mt-2'>
                                    <p>Arquivos a processar:</p>
                                    <ul>
                                        {arquivos.filter(f => f.tipo === 'Saldo Inicial' && !f.processado).map((item) => (
                                            <li key={item.id}>{item.nome} - <button onClick={() => {
                                                ArquivoEmpresaService.removerArquivoEmpresa(item.id).then(() => {
                                                    setArquivos((old) => {
                                                        const copy = [...old];
                                                        const index = copy.findIndex(f => f.id === item.id);
                                                        if (index > -1) {
                                                            copy.splice(index, 1);
                                                        }
                                                        return copy;
                                                    });
                                                });
                                            }} className='text-danger btn btn-default'>Remover</button></li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            {arquivos.filter(f => f.tipo === 'Saldo Inicial' && f.processado).length > 0 && (
                                <div className='col-md-12 mt-2'>
                                    <p>Arquivos processados:</p>
                                    <ul>
                                        {arquivos.filter(f => f.tipo === 'Saldo Inicial' && f.processado).map((item) => (
                                            <li key={item.id}>{item.nome}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <div className='col-md-12 mt-2'>
                                <p>Após importar o(s) arquivo(s) clique em processar arquivos para iniciar a leitura e processamento dos dados.</p>
                                <p>Após processado o arquivo será movido para a seção de arquivos processados.</p>
                            </div>
                            <div className="col-md-12 mt-2">
                                <button style={{ width: '100%' }} className='btn btn-success' disabled={arquivos.filter(f => f.tipo === 'Saldo Inicial' && !f.processado).length === 0} onClick={() => {
                                    ArquivoEmpresaService.enviarSaldoInicialParaFila(esteiraID);

                                    setArquivos((old) => {
                                        const copy = [...old];

                                        copy.forEach((item, index) => {
                                            if (item.tipo === 'Saldo Inicial' && !item.processado) {
                                                copy[index].processando = true;
                                            }
                                        });

                                        return copy;
                                    });

                                    Swal.fire({
                                        text: t('Arquivo(s) enviados para processamento.'),
                                        timer: 30000,
                                        icon: 'success',
                                        showConfirmButton: true,
                                        confirmButtonText: 'OK'
                                    });

                                }}>Processar Arquivos</button>
                            </div>
                            <div className="col-md-12 mt-2">
                                <button style={{ width: '100%' }} className='btn btn-success' disabled={arquivos.filter(f => f.tipo === 'Saldo Inicial' && (!f.processado || f.processando)).length > 0} onClick={() => {
                                    ArquivoEmpresaService.concluirImportacaoBloqueio(esteiraID);
                                    toggleModal();

                                    Swal.fire({
                                        text: t('Processo concluído! Em 15 segundos iremos atualizar sua página.'),
                                        timer: 30000,
                                        icon: 'success',
                                        showConfirmButton: true,
                                        confirmButtonText: 'OK'
                                    });

                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 15000);

                                }}>Continuar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default ModalArquivosIniciais